export const fontWeights = {
  xs: 100,
  s: 200,
  sm: 300,
  m: 400,
  ml: 500,
  l: 600,
  xl: 700,
};
